<template>
  <div
    v-if="upsellItems.length > 0"
    class="section"
  >
    <div class="flex justify-between half-spacing">
      <h2 :class="['title title--6 dark-gray no-spacing', { 'center': upsellItems.length === 1 }]">
        {{ upsellContent }}
      </h2>
      <div
        v-if="upsellItems.length > 1"
        class="hide-for-no-pointer flex three-quarter-gap half-negative-spacing-top"
      >
        <button
          class="button button--small button--light button--light-text button--icon no-spacing"
          type="button"
          title="Scroll to previous item"
          @click="scroll('previous')"
        >
          <span class="icon far fa-arrow-left" />
        </button>
        <button
          class="button button--small button--light button--light-text button--icon no-spacing"
          type="button"
          title="Scroll to next item"
          @click="scroll('next')"
        >
          <span class="icon far fa-arrow-right" />
        </button>
      </div>
    </div>

    <div :class="['menu-list menu-list--carousel', { 'menu-list--single-item': upsellItems.length === 1 }]">
      <div
        ref="carousel"
        class="menu-list__carousel"
      >
        <div class="menu-list__items">
          <menu-list-item
            v-for="item in parsedUpsellItems"
            :key="item.menuItemId"
            ref="item"
            :item="item"
            @open-item="openItem(item)"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import MenuListItem from '@/components/globals/menu-list/components/menu-list-item.vue';

  export default {
    name: 'UpsellOrderItems',

    components: {
      MenuListItem
    },

    computed: {
      ...mapGetters('orders', ['upsellItems']),
      ...mapGetters('content', ['content']),

      upsellContent() {
        return this.content.OrderSummary.metadata.upsell;
      },

      parsedUpsellItems() {
        return [...new Map(this.upsellItems.map(item => [item.menuItemId, item])).values()];
      }
    },

    watch: {
      upsellItems: 'upsellItemsChangeHandler'
    },

    methods: {
      openItem(item) {
        this.$store.dispatch('menu/selectItem', {
          isUpsell: item.isUpsell,
          itemId: item.menuItemId
        });

        // this.$triggerGoogleTrackingEvent('UpsellItemViewed', 'Checkout');

        this.$triggerNewRelicEvent('UpsellItemViewed', 'Information', 'Upsell Item Viewed');

        this.$openModal('menuItem');
      },

      scroll(direction) {
        /*
          NOTE: Due to complex DOM interaction, this method
          isn't unit tested yet.
        */

        const { carousel } = this.$refs;
        const itemWidth = this.$refs.item[0].$el.clientWidth;
        const scrollDistance = itemWidth;

        if (direction === 'previous') {
          if (carousel.scrollLeft === 0) {
            carousel.scrollTo({
              left: carousel.scrollWidth,
              behavior: 'smooth'
            });
          }

          else {
            carousel.scrollBy({
              left: scrollDistance * -1,
              behavior: 'smooth'
            });
          }
        }

        else if (carousel.scrollWidth - carousel.scrollLeft === carousel.clientWidth) {
          carousel.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }

        else {
          carousel.scrollBy({
            left: scrollDistance,
            behavior: 'smooth'
          });
        }
      },

      async upsellItemsChangeHandler() {
        await this.$nextTick();

        if (this.$refs.menuCarousel) {
          this.$refs.menuCarousel.scrollLeft = 0;
        }
      }
    }
  };
</script>
